import React, {MouseEventHandler} from 'react'
import {EntryDesc} from 'generated/JavaTOmodifications'
import {StornoIconComponent} from 'module/Storno/component/StornoIconComponent'
import {getEntryDescStyleObj} from 'module/edesc/EntryDescUtil'
import {css} from '@emotion/react'
import FontAwesome from 'react-fontawesome'
import {SisName} from 'util/SisName'
import {dropFAPrefix} from 'module/maintenance/util/dropFAPrefix'

const cssShortLabel = css`
	text-align: center;
`
const cssPrimaryShortLabel = css`
	min-width: 38px;
`
const cssSecondaryShortLabel = css`
	font-size: 9px;
`
const cssIconLabelMap = {
	[SisName.Booking]: css`
		font-size: 18px;
		padding-top: 1px;
	`,
	[SisName.Persurl]: css`
		padding-top: 1px;
	`,
}

interface Props {
	className?: string
	entryDesc?: EntryDesc
	dev?: string
	showStornoIcon?: boolean
	onClick?: MouseEventHandler
}

export function EntryDescShortLabelComponent({className, entryDesc, dev, showStornoIcon, onClick}: Props) {
	if (!entryDesc) return null;
	const typeColorStyle = !entryDesc ? {} : getEntryDescStyleObj(entryDesc, dev)
	const {icon, primaryShortLabel, secondaryShortLabel, longLabel, sisName} = entryDesc || {}
	let _icon = dropFAPrefix(icon);
	const shortLabel = !entryDesc ? <>??</> : <div css={cssShortLabel}>
		{showStornoIcon && <StornoIconComponent/>}
		{_icon &&
			<FontAwesome css={cssIconLabelMap[sisName]} name={_icon}/>
			|| <>
				<div css={cssPrimaryShortLabel}>{primaryShortLabel}</div>
				<div css={cssSecondaryShortLabel}>{secondaryShortLabel}</div>
			</>
		}
	</div>
	return <div
		style={typeColorStyle}
		className={className}
		onClick={onClick}
		title={longLabel}
	>
		{shortLabel}
	</div>
}